import { Card, Col, Form, Row } from 'antd';
import { CreateLayout } from '../../../components/layout/layout/CreateLayout';
import { FolderOutlined } from '@ant-design/icons';
import { IAcademicRecordEquivalency } from 'interfaces/academic_record_equivalencies';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { SearchAcademicRecord } from './components/SearchAcademicRecord';
import { useForm } from '@refinedev/antd';
import { useState } from 'react';

export const AcademicRecordEquivalencyCreate = () => {
  const { formProps, saveButtonProps, form } =
    useForm<IAcademicRecordEquivalency>({
      successNotification: () => ({
        type: 'success',
        message: 'Equivalência de disciplinas criada com sucesso',
        description: 'Histórico escolar criado com sucesso'
      }),
      errorNotification: () => ({
        type: 'error',
        message: 'Erro ao criar equivalência de disciplinas',
        description: 'Erro'
      })
    });

  const [step, setStep] = useState(0);

  return (
    <CreateLayout
      saveButtonProps={{ ...saveButtonProps, disabled: step === 0 }}
    >
      <PageHeader
        title="Criar Equivalência Interna de Histórico Acadêmico"
        icon={FolderOutlined}
      />
      <Card>
        <Form {...formProps} layout="vertical">
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <SearchAcademicRecord onChange={setStep} form={form} />
            </Col>
          </Row>
        </Form>
      </Card>
    </CreateLayout>
  );
};
